import React, { useEffect, useState } from 'react';
import DataTable from '../../../../Components/Others/DataTable';
import { CancelButton, CreateButton, FilterButton, ImportButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import UseGetData from '../../../../Components/Hooks/useFetchData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import MoreOptions from '../../../../Components/Utils/MoreOptions';
import PremiumTable from '../../../../Components/Others/PremiumTable';
import List from '../../../../Components/Icons/list';
import Card from '../../../../Components/Icons/card';
import CustomerCard from './CustomerCard';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import Pagination from '../../../../Components/Utils/Pagenation';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useFetchMetaStar from '../../../../Components/Hooks/useFetchMetaStar';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { NuInput } from '../../../../Components/Utils/Input';
import { CountryMIN } from '../../../../assets/CountryMini';
import Importdoc from './Importdoc';
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from '../../../../Components/Utils/roles';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import useFetchMetaStarIndex from '../../../../Components/Hooks/useFetchMetaStarIndex';
import { useDeleteData } from '../../../../Components/Hooks/useDeleteData';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import ViewToggle from '../../../../Components/Utils/ViewToggle';
import UseDropDown from '../../../../Components/Hooks/useDropDown';

// Customer Table Row Component
const CustomerTableRow = ({
  row,
  isSelected,
  onSelect,
  canEdit,
  canDelete,
  handleDelete,
  pageIndex,
  searchQuery,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/customers/" + `${row.customerId}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white hover:bg-white/80 transition-colors align-middle border-b border-gray-100">
        {/* ID */}
        <td className="p-4 align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.customerId}
        </td>

        {/* Company Name */}
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <Link
            to={`/sales/customers/view/${row.customerId}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="hover:underline text-sm font-bold text-gray-800"
          >
            {row.companyName || "N/A"}
          </Link>
        </td>

        {/* Industry */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">
          {row.industry || "N/A"}
        </td>

        {/* Location */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.billing_city || "N/A"}
        </td>

        {/* Contact Person */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.cpName || "N/A"}
        </td>

        {/* Mobile */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.phoneWithCC || "N/A"}
        </td>

        {/* Action Buttons */}
        <td className="p-4 text-center align-middle border-t border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
          <div className="flex items-center justify-center gap-1.5">
            {/* View */}
            <Link
              to={`/sales/customers/view/${row.customerId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="View details"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </Link>
            {/* Edit */}
            {CheckEditAction(row, "Customers", canEdit) && (
              <Link
                to={`/sales/customers/edit/${row.customerId}`}
                state={{
                  data: row,
                  from: "/sales/customers",
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Edit Customer"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </Link>
            )}
            {/* Delete */}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Delete Customer"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.companyName} will be removed from Customers!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

function CustomersIndex() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const state = location.state;

  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [filter, setFilter] = useState(state?.industry ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: customerRating } = useFetchMetaStarIndex(`/dropdown/dropdown-details/`, 'customerRating_Customer', showFilterDialog)
  const { value: Status } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Status_Customer', showFilterDialog)
  const { value: customerType } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'customerType_Customer', showFilterDialog)
  const { value: Industry } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Industry_Customer', showFilterDialog)
  const { value: Category } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'category_Customer', showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    country: "",
    category: "",
    paymentTerm: "",
    ratings: "",
    status: "",
    industry: "",
    customerType: "",
    approvalStatus: "",

  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    searchBy: "",
    country: "",
    // category:state?.category? state.category :"",

    category: "",
    paymentTerm: "",
    ratings: "",
    status: "",
    industry: state?.industry ? state.industry : "",
    customerType: "",
    approvalStatus: "",

  });
  const clearFilter = () => {
    setParams({
      ...params, country: "",
      category: "",
      paymentTerm: "",
      ratings: "",
      status: "",
      industry: "",
      approvalStatus: "",

      customerType: ""
    })
    formik.values.status = ""
    formik.values.customerType = ""
    formik.values.category = ""
    formik.values.paymentTerm = ""
    formik.values.industry = ""
    formik.values.country = ""
    formik.values.ratings = ""
    formik.values.approvalStatus = ""



    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, country: value.country, industry: value.industry, paymentTerm: value.paymentTerm, category: value.category, ratings: value.ratings, status: value.status, customerType: value.customerType, approvalStatus: value.approvalStatus })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        country: "",
        category: "",
        paymentTerm: "",
        ratings: "",
        status: "",
        industry: "",
        customerType: "",
        approvalStatus: ""
      });
    }
  })

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch("/customers/", params);
  const [viewMode, setViewMode] = useState(localStorage.getItem("customersViewMode") || "card");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);

  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.customerId);
      });
    setFullList(tempArr);
  }, [data]);

  const canEdit = GetAccess("customers_edit") || GetRole();
  const canDelete = GetAccess("customers_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  const defaultHeader = [
    {
      title: "ID",
      width: "5%",
      field: "customerId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Company Name",
      width: "10%",
      isLink: true,
      id: "customerId",
      link: '/sales/customers/view/',
      field: "companyName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Industry ",
      width: "10%",
      field: "industry",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Location ",
      width: "10%",
      field: "billing_city",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person",
      width: "10%",
      field: "cpName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mobile ",
      width: "10%",
      field: "phoneWithCC",
      // subField: "display",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "customerId",
        removeValue: "companyName",
        url: `/customers/`,
        moduleName: "Customers",
        from: `/sales/customers`,
        editLink: "/sales/customers/edit/",
        viewLink: "/sales/customers/view/"

      }
    },
  ];
  const availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "customerId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Company Name",
      width: "10%",
      isLink: true,
      id: "customerId",
      link: '/sales/customers/view/',
      field: "companyName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Industry ",
      width: "10%",
      field: "industry",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Location ",
      width: "10%",
      field: "city",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person",
      width: "10%",
      field: "cpName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mobile ",
      width: "10%",
      field: "phoneWithCC",
      // subField: "display",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer Type ",
      width: "10%",
      field: "customerType",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Email",
      width: "10%",
      field: "email",
      type: "email",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Website",
      width: "10%",
      field: "website",
      textAlign: "center",
      rowAlign: "center",
    },

    // {
    //   title: "Billing Address ",
    //   width: "10%",
    //   field: "billingAddress",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    // {
    //   title: "Shipping Address ",
    //   width: "10%",
    //   field: "shippingAddress",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "CR Num ",
      width: "10%",
      field: "crNum",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Vat Num ",
      width: "10%",
      field: "vatNum",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Ratings ",
      width: "10%",
      field: "ratings",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Payment Term ",
      width: "10%",
      field: "paymentTerm",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Credit Limit ",
      width: "10%",
      field: "creditLimit",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Designation ",
      width: "10%",
      field: "designation",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Comments ",
    //   width: "10%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Country ",
      width: "10%",
      field: "country",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "State ",
      width: "10%",
      field: "state",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "District ",
      width: "10%",
      field: "district",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Postal Code",
      width: "10%",
      field: "postalCode",
      textAlign: "center",
      rowAlign: "center",
    },


    {
      title: "Cont. Person Email ",
      width: "10%",
      field: "cpEmail",
      type: "email",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Contact Person No.",
      width: "10%",
      field: "cpPhoneWithCC",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "customerId",
        removeValue: "companyName",
        url: `/customers/`,
        moduleName: "Customers",
        from: `/sales/customers`,
        editLink: "/sales/customers/edit/",
        viewLink: "/sales/customers/view/"

      }
    },
  ];
  useEffect(() => {
    localStorage.setItem("customersViewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount, viewMode])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  return (
    <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb items={[
            {
              name: "Sales",
            },
            {
              name: "Customer"
            }
          ]} />
          <div className="flex md:hidden items-center gap-1.5 flex-wrap">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
            {GetRole() && <ImportButton handleClick={handleImportClick} />}
            {GetAccess("customers_create") && <Link to="/sales/customers/create/"><CreateButton label='Customer' /></Link>}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center justify-between md:justify-start gap-2'>
          <div className="w-full md:w-auto flex-1 min-w-0">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>

          <div className="hidden md:flex items-center gap-2">

            <ViewToggle
              viewMode={effectiveViewMode}
              onViewChange={(mode) => setViewMode(mode)}
              storageKey="customersViewMode"
            />
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
            {GetRole() && <ImportButton handleClick={handleImportClick} />}
            {GetAccess("customers_create") && <Link to="/sales/customers/create/"><CreateButton label='Customer' /></Link>}
          </div>
        </div>
      </div>
      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "ID", width: "100px" },
          { title: "Company Name", width: "auto" },
          { title: "Industry", width: "180px" },
          { title: "Location", width: "160px" },
          { title: "Contact Person", width: "180px" },
          { title: "Mobile", width: "160px" },
          { title: "Action", align: "center", width: "120px" }
        ]}
        renderRow={(row, idx) => (
          <CustomerTableRow
            row={row}
            isSelected={listofNumbers.includes(row.customerId)}
            onSelect={() => selectOneFunction(row.customerId)}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            pageIndex={page}
            searchQuery={params?.search || ""}
          />
        )}
        renderCard={(row, idx) => (
          <CustomerCard
            item={row}
            key={idx}
            fetcher={getData}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            pageIndex={page}
            searchQuery={params?.search || ""}
          />
        )}
        dataLoading={dataLoading}
      />
      {showFilterDialog && (


        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter Customer</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
                <FormikSelectTwo
                  type="text"
                  label="Customer Type"
                  placeholder="Customer Type"
                  Options={customerType}
                  formik={formik}
                  name="customerType"
                  width="w-full "
                />
                <FormikSelectTwo
                  type="text"
                  label="Country"
                  placeholder="Country"
                  Options={CountryMIN}
                  formik={formik}
                  name="country"
                  width="w-full "
                />

                <FormikSelectTwo
                  type="text"
                  label="Industry"
                  placeholder="Choose"
                  Options={Industry}
                  formik={formik}
                  name="industry"
                  width="w-full "
                />
                <FormikSelectTwo
                  label="Ratings"
                  placeholder="Ratings"
                  Options={customerRating}
                  formik={formik}
                  name="ratings"
                  width="w-full "
                />
                <NuInput
                  type="text"
                  label="Payment Term"
                  placeholder="payment Term"
                  formik={formik}
                  name="paymentTerm"
                  width="w-full "
                />
                <FormikSelectTwo
                  type="text"
                  label="Category"
                  placeholder="Choose"
                  Options={Category}
                  formik={formik}
                  name="category"
                  width="w-full "
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Status"
                  Options={Status}
                  formik={formik}
                  name="status"
                  width="w-full "
                />


              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name='Apply' />
              </div>
            </form>
          </div>
        </div>
      )}

      {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
    </div>
  )
}

export default CustomersIndex